import InviraRolesList from './InviraRolesList.vue'
export {InviraRolesList}
export default InviraRolesList

